import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { apiGet } from '../api';
import { canWriteProjects } from '../permissions';
import './DashboardPage.css';

/**
 * Full project list. The landing page for the project → suite → case
 * hierarchy (reachable from the "Projects" nav item and /projects).
 */
function ProjectsPage({ user }) {
  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const canCreate = canWriteProjects(user);

  useEffect(() => {
    let cancelled = false;
    apiGet('/projects')
      .then((data) => {
        if (!cancelled) setProjects(data);
      })
      .catch((err) => {
        console.error('Error loading projects:', err);
        if (!cancelled) setError('Failed to load projects');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="dashboard-page">
      <div className="container">
        <div className="dashboard-title-row">
          <div>
            <h1>Projects</h1>
            <p className="welcome">Open a project to manage its test suites and cases.</p>
          </div>
          {canCreate && (
            <button className="btn btn-primary" onClick={() => navigate('/projects/new')}>
              + New Project
            </button>
          )}
        </div>

        {error && <div className="error-banner">{error}</div>}

        <div className="dashboard-projects-col">
          {loading ? (
            <div className="loading">Loading projects...</div>
          ) : projects.length === 0 ? (
            <div className="empty-state">
              <p>No projects yet.{canCreate ? ' Create one to get started!' : ''}</p>
            </div>
          ) : (
            <div className="projects-list">
              {projects.map((project) => (
                <div key={project.id} className="project-row">
                  <div className="project-row-main">
                    <div className="project-row-name">{project.name}</div>
                    <div className="project-row-desc">{project.description || 'No description'}</div>
                  </div>
                  <Link to={`/projects/${project.id}`} className="btn btn-secondary btn-small project-row-open">
                    Open
                  </Link>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ProjectsPage;
